import React, { Component } from 'react';

class PhotoSlider extends Component {
  state = {
    startIndex: 0,
    totalImages: this.props.postContent.fields.media.length,
    isVisible: 'off__screen'
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  updateSlideNumberNext = () => {
    this.state.startIndex <= this.state.totalImages - 2 ?
      this.setState({ startIndex: this.state.startIndex + 1 }) :
      this.setState({ startIndex: 0 })
  }

  updateSlideNumberPrev = () => {
    this.state.startIndex > 0 ?
      this.setState({ startIndex: this.state.startIndex - 1 }) :
      this.state.startIndex === 0 ?
        this.setState({ startIndex: this.state.totalImages - 1 }) :
        this.setState({ startIndex: this.state.totalImages - 1 })
  }

  handleScroll = () => {
    let windowScroll = window.scrollY;
    let elementScroll = !this.divElement ? 900 : this.divElement.offsetTop - this.divElement.clientHeight - 560;
    if (windowScroll > elementScroll) { this.setState({ isVisible: 'on__screen' }) }
  }


  render() {
    let post = this.props.postContent.fields;

    let imageCarousel = post.media.map((images, index) => {

      if (index === this.state.startIndex) {
        let arrows;
        post.media.length > 2 ? arrows = 'arrows' : arrows = 'no-arrows';

        return (
          <div key={index} style={{ "transitionDelay": `${index * .25}s` }}
            className={`photo__slider ${this.state.isVisible} ${this.props.isStart} ${arrows}`} ref={(divElement) => this.divElement = divElement}>
            <div className={`image__container ${images.fields.file.details.image.width > images.fields.file.details.image.height ? "horizontal" : "vertical"}`}>
              <div className="image__inner">
                <img
                  width={images.fields.file.details.image.width}
                  height={images.fields.file.details.image.height}
                  ser-set={images.fields.file.url}
                  src={this.props.isStart === "on__screen" ? images.fields.file.url : this.state.isVisible === "on__screen" ? images.fields.file.url : this.props.viewType === "grid" ? images.fields.file.url : null}
                  alt={`${images.fields.file.url} - Claire Arnold | Creative Director | Director`} />
                <img src={images.fields.file.url} alt={images.fields.file.url} style={{ display: 'none' }} />
                <div onClick={this.updateSlideNumberPrev} className="previous"></div>
                <div onClick={this.updateSlideNumberNext} className="next"></div>
              </div>
              <div className="photo__info">
                <h4>{post.showTitle === true && post.titles}</h4>
                <div className="indicators">
                  {post.media.length > 2 &&
                    <div><span>{index + 1}</span>:<span>{post.media.length}</span> </div>
                  }
                </div>
              </div>
            </div>
          </div>


        )
      }
      else {
        return null;
      }
    })


    return (
      <div>
        {imageCarousel}
      </div>
    );
  }
}



export default PhotoSlider;



// WEBPACK FOOTER //
// ./src/PhotoJournal/PhotoSlider.js